import { Translation } from '@ps/web-shared-components';
import type { PlaceTerms } from '@ps/web-sports-api-types';
import React from 'react';

import {
  TXTWCL_Each_Way_termsX_N0_odds_for_fi_ELL,
  TXTWCL_Each_wayX_N0_odds___N1_places
} from './EachWayPlaceTerms.messages.json';

export interface Props {
  placeTerms?: PlaceTerms;
  className?: string;
  variant?: 'long' | 'short';
}

export const EachWayPlaceTerms: React.FC<Props> = ({
  placeTerms,
  className,
  variant = 'short'
}) => {
  if (placeTerms) {
    return (
      <div className={className}>
        <Translation
          values={{ 0: placeTerms.deductionFraction, 1: placeTerms.numPlaces }}
          {...(variant === 'short'
            ? TXTWCL_Each_wayX_N0_odds___N1_places
            : TXTWCL_Each_Way_termsX_N0_odds_for_fi_ELL)}
        />
      </div>
    );
  }

  return null;
};

export default EachWayPlaceTerms;
